import { render } from "./PayLinkPage.vue?vue&type=template&id=bd500732&scoped=true"
import script from "./PayLinkPage.vue?vue&type=script&lang=js"
export * from "./PayLinkPage.vue?vue&type=script&lang=js"

import "./PayLinkPage.vue?vue&type=style&index=0&id=bd500732&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd500732"]])

export default __exports__